export enum AccreditationRequestErrors {
  CredentialAlreadyExist = "accreditation-request/credential-already-exists",
}
